import { NgModule } from '@angular/core'
import { MultiChannelPlaylistModule } from '../multi-channel-playlist/multi-channel-playlist.module'
import { AudioSegmentService } from './audio-segment.service'

@NgModule({
  imports: [MultiChannelPlaylistModule],
  providers: [AudioSegmentService],
})
export class AudioSegmentServiceModule {}
